module.exports = "/img/_/_/_/assets/images/creeper/battle/common//9.jpg?8b3d7afee7809ee0c25a553440a496af";